module.exports = __webpack_public_path__ + "static/media/circle_icon.b77d2842.svg";